import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initializeInsider } from './integrations/insider';
import { initializeGtm } from './integrations/gtm';
import { initializeMetaPixel } from './integrations/metaPixel';
import './index.css';

// Initialize Insider SDK (once, before render)
initializeInsider();
initializeGtm();
initializeMetaPixel();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
